import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: "G-R5QVEZETG1"
};

// Initialize Firebase
let app: firebase.app.App;
if (!firebase.apps.length) {
  app = firebase.initializeApp(firebaseConfig);
} else {
  app = firebase.app();
}

const auth = app.auth();
auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

// Initialize Firestore
const db = firebase.firestore();
db.settings({
  ignoreUndefinedProperties: true,
  merge: true
});

const googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.setCustomParameters({ 
  prompt: 'select_account'
});

const githubProvider = new firebase.auth.GithubAuthProvider();

export { app, auth, db, googleProvider, githubProvider }; 